class HeaderPrimary {
  constructor() {
    this._init();
  }

  _init() {
    if (!this.isPWA()) {
      const floatButton = document.querySelector(
        '.header-primary__float-button'
      );
      if (floatButton) {
        floatButton.classList.add('header-primary__float-button--active');
      }
    } else {
      // Dont show the float button
    }
  }

  isPWA() {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      (window as any).navigator.standalone === true
    );
  }
}

export const headerPrimary = new HeaderPrimary();
